import React from 'react';
import styled from '@emotion/styled';
import { Box, Container } from '@qga/roo-ui/components';

import useSize from '@shared/v2/hooks/useSize';

import NavButton from './components/InPageNavButton';
import { NavItem } from './types';

export type InPageNavigationProps = {
  navItems: NavItem[];
};

const Nav = styled(Box)`
  white-space: nowrap;
  overflow-x: auto;
`;

const Content = styled(Container)`
  display: flex;
  gap: 8px;
`;

const InPageNavigation = ({ navItems }: InPageNavigationProps) => {
  const { height, ref } = useSize();

  return (
    <Nav
      ref={ref}
      display={['none', null, 'initial']}
      position="sticky"
      top="0"
      zIndex="100"
      backgroundColor="white"
      borderBottom="1"
      borderColor="greys.alto"
    >
      <Content>
        {navItems.map((item) => (
          <NavButton key={item.key} navItem={item} navHeight={height} />
        ))}
      </Content>
    </Nav>
  );
};

export default InPageNavigation;
